"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class DatabaseUtils {
    static async clear(db) {
        const keysToClear = new Array();
        return new Promise((resolve, reject) => {
            db.createKeyStream()
                .on("data", (key) => {
                keysToClear.push(key);
            })
                .on("error", (error) => {
                reject(error);
            })
                .on("close", async () => {
                for (const key of keysToClear) {
                    await db.del(key);
                }
                resolve();
            });
        });
    }
}
exports.DatabaseUtils = DatabaseUtils;
//# sourceMappingURL=utils.js.map